import React from "react";
import {useSelector} from "react-redux";
import {Link, useParams} from "react-router-dom";
import Box from "@mui/material/Box";
import {Grid, Typography} from "@mui/material";
import {galleryLink} from "../utils/linkMaker";
import MtgOffers from "./MtgOffers";
import Button from "@mui/material/Button";
import Chip from '@mui/material/Chip';

const MtgSealed = () => {

    const {items: cards} = useSelector((state) => state.cardReducer)
    const {id} = useParams();
    const box = cards.find(c => c.id == id)

    if (!box) return

    return (
        <>
            <Box height={48}/>
            <Grid container spacing={{xs: 1, sm: 2, md: 2}} columns={{xs: 1, sm: 2, md: 4}}>
                <Grid item xs={1} sm={1} md={1}>
                    <Box
                        component="img"
                        sx={{
                            maxWidth: {xs: "100%", md: "100%"}, borderRadius: 4,
                        }}
                        alt={box.name}
                        src={galleryLink(box.object, box.id)}
                    />
                </Grid>
                <Grid item xs={1} sm={1} md={3}>
                    <Grid container spacing={{xs: 1}} columns={{xs: 1, sm: 2, md: 2}}>
                            <Typography
                                variant="h4">{box.name}</Typography>
                    </Grid>
                    <Grid container spacing={{xs: 1, sm: 1, md: 2}} columns={{xs: 1, sm: 1, md: 1}}>
                        <Grid item xs={1} sm={1} md={1}>
                            <Typography variant="h6">March of the Machine</Typography><br/>
                            <Typography>{box.typeline}</Typography><br/>
                            <Typography>{box.oracle_text}</Typography><br/>
                        </Grid>
                    </Grid>

                </Grid>
{/*
                <Grid item md={1}>
                            <Button variant="outlined" component={Link} to={`/search?q=march%20of%20the%20machine`}>
                                View all MOM products
                            </Button>
                            <Box height={8}/>
                        <Typography variant="h6">Related Products
                        </Typography>
                        <Box height={8}/>
                        <Grid container spacing={{md: 1}} columns={{md: 1, lg: 1, xl: 1}}>
                            <Grid item xs={1} sm={1} md={1}>
                                <Chip component={Link} to={`/search?q=march%20of%20the%20machine`}
                          sx={{
                              width: "100%", margin: 0.2, '& .MuiChip-label': {
                                  textAlign: "left", width: "100%"
                              }
                          }}
                          variant="outlined"
                          label={`March of the Machine Collector's Booster Box`}
                    />
                    <Chip component={Link} to={`/search?q=march%20of%20the%20machine`}
                          sx={{
                              width: "100%", margin: 0.2, '& .MuiChip-label': {
                                  textAlign: "left", width: "100%"
                              }
                          }}
                          variant="outlined"
                          label={`March of the Machine Jumstart Booster Box`}
                    />
                    <Chip component={Link} to={`/search?q=march%20of%20the%20machine`}
                          sx={{
                              width: "100%", margin: 0.2, '& .MuiChip-label': {
                                  textAlign: "left", width: "100%"
                              }
                          }}
                          variant="outlined"
                          label={`March of the Machine Set Booster Box`}
                    />
                            </Grid>
                        </Grid>
                    </Grid>
*/}
            </Grid>
            <Box height={24}/>
            <MtgOffers cardId={box.id} objectType={box.object}/>

            <Box height={24}/>


        </>
    )
}

export default MtgSealed;
